// extracted by mini-css-extract-plugin
export default {"services":"Services_services__UtyVj","tabWrapper":"Services_tabWrapper__x5z7m"};